export default __webpack_public_path__ + "static/media/ldscustomer.1c4e345d.jpg";